import { useSelectedCase } from '../../state/contexts/AppDataContext';
import { useUIState } from '../../state/contexts/UIStateContext';
import { SendNotificationModal } from './SendNotificationModal';
import { UnsuccessfulDecisionModal } from './UnsuccessfulDecisionModal';
import { SubmitChangeModal } from './SubmitChangeModal';
import { LogLegalProcessModal } from './LogLegalProcessModal';
import { AddFinancialRefModal } from './AddFinancialRefModal';
import { NewShaftDisputeModal } from './NewShaftDisputeModal';
import { NewIpDisputeModal } from './NewIpDisputeModal';
import { ValidationErrorModal } from './ValidationErrorModal';
import { ShaftResponseModal } from './ShaftResponseModal';
import { IpCounterClaimModal } from './IpCounterClaimModal';
import { AuditReportModal } from './AuditReportModal';
import { CreateUserModal } from './CreateUserModal';
import { CreateIntakeClientModal } from './CreateIntakeClientModal';
import { DeleteRegistrationDialog } from './DeleteRegistrationDialog';
import type { Case } from '../../domain/initial-cases';

export function Modals() {
  const { modal, modalData } = useUIState();
  const c = useSelectedCase();

  if (!modal) return null;

  switch (modal) {
    case 'send-notification':       return c ? <SendNotificationModal c={c} /> : null;
    case 'unsuccessful-decision':   return c ? <UnsuccessfulDecisionModal c={c} /> : null;
    case 'submit-change':           return c ? <SubmitChangeModal c={c} /> : null;
    case 'log-legal-process':       return <LogLegalProcessModal />;
    case 'add-financial-ref':       return c ? <AddFinancialRefModal c={c} /> : null;
    case 'new-shaft-dispute':       return <NewShaftDisputeModal />;
    case 'new-ip-dispute':          return <NewIpDisputeModal />;
    case 'validation-error':        return <ValidationErrorModal />;
    case 'shaft-response':          return modalData.disputeId ? <ShaftResponseModal /> : null;
    case 'ip-counter-claim':        return modalData.disputeId ? <IpCounterClaimModal /> : null;
    case 'audit-report':            return <AuditReportModal />;
    case 'create-user':             return <CreateUserModal />;
    case 'create-intake-client':    return <CreateIntakeClientModal />;
    // #691 — the only case-modal that does NOT read `useSelectedCase()` first.
    // It opens from two places and one of them is Customers › Registrations,
    // which never sets a selected case: that page fetches the promoted case on
    // demand and hands it over in `modalData`. The selected case is the
    // fallback so the case-header trigger stays a one-liner, and `onDeleted`
    // travels the same way because what happens after a successful delete is
    // the call site's business — navigate off the detail view, or refetch the
    // submissions list.
    case 'delete-registration': {
      const target = (modalData.case as Case | undefined) ?? c;
      return target
        ? <DeleteRegistrationDialog c={target} onDeleted={modalData.onDeleted as (() => void) | undefined} />
        : null;
    }
    default:                        return null;
  }
}
